<template>
  <div
    v-if="error"
    class="flex min-h-screen flex-col items-center justify-center p-6 md:p-8"
  >
    <h1 class="text-4xl font-medium text-red-600">
      Error {{ error.statusCode }}
    </h1>
    <p class="mt-2 text-xl">
      {{ error.message || "An error occurred" }}
    </p>

    <div
      v-if="isDev && error.stack"
      class="mt-6 w-full max-w-3xl overflow-auto rounded-md bg-gray-50 p-6"
    >
      <pre class="whitespace-pre-wrap text-sm">{{ error.stack }}</pre>
    </div>

    <Button
      class="mt-8"
      @click="handleError"
    >
      Back to Home
    </Button>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'
import Button from './components/wk/elements/Button.vue'

defineProps({
  error: Object as () => NuxtError
})

const isDev = import.meta.env.NODE_ENV === 'development'

const handleError = () => clearError({ redirect: '/' })
</script>
